// THEMIS · PROTOCOL — the protocol bound to the orb's current Step (c.protocol / c.routine) and its runner (orb/runner.ts).
import type { OrbWidgetModel, WidgetCtx } from '../types';
import { emptyModel } from './util';

const BASE = { id: 'themis', toolId: 'themis', orderFunction: 'execute', title: 'PROTOCOL', deityName: 'THEMIS', agentId: 'themis' } as const;

export function useThemisWidget(c: WidgetCtx): OrbWidgetModel {
  const { protocol, routine, runner } = c;
  if (!protocol) return emptyModel(BASE, c, 'No active protocol', { label: 'Open Themis', run: () => c.openTool('themis'), tone: 'gold' });

  const n = routine?.length ?? 0;
  const hasRoutine = n > 0;
  const done = hasRoutine ? (runner.finished ? n : Math.min(runner.idx, n)) : 0;
  const cur = hasRoutine ? routine![Math.min(runner.idx, n - 1)] : null;

  const lines: string[] = [protocol.title];
  if (hasRoutine) {
    lines.push(runner.finished ? `All ${n} steps done` : `Step ${Math.min(runner.idx + 1, n)}/${n}: ${cur?.title ?? ''}`);
    lines.push(`Completion: ${done}/${n}`);
  } else {
    lines.push('Protocol has no steps');
  }

  const raw = hasRoutine ? `${protocol.title} · ${done}/${n}` : protocol.title;
  return {
    ...BASE,
    status: runner.running ? 'active' : 'quiet',
    summary: raw.length > 40 ? `${raw.slice(0, 39).trimEnd()}…` : raw,
    lines,
    agentId: BASE.agentId,
    primaryAction: { label: 'Next step', run: () => runner.next(), tone: 'gold', disabled: !hasRoutine || runner.finished },
    secondaryActions: [{ label: 'Open Themis', run: () => c.openTool('themis', { initialProtocolId: protocol.id }) }],
    signals: { active: runner.running || hasRoutine, related: true },
  };
}
